(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.testimonial-slider', {
  loop: true,
    slidesPerView: 4,
    spaceBetween: 20,
      autoplay: {
        delay: 3000, // 3 seconds per slide
        disableOnInteraction: false, // keep autoplay after user interacts
      },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 4 }
    },
    pagination: {
     // el: '.swiper-pagination',
      clickable: true,
    },
 breakpoints: {
  375: {   // up to small mobiles
    slidesPerView: 1,
    spaceBetween: 10,
  },
  480: {   // small devices
    slidesPerView: 2,
    spaceBetween: 15,
  },
  768: {   // tablets
    slidesPerView: 3,
    spaceBetween: 20,
  },
  1360: {  // large screens (1360px and above)
    slidesPerView: 3,
    spaceBetween: 25,
  },
  1440: {  // full desktop
    slidesPerView: 4,
    spaceBetween: 30,
  }
}
  });

  } catch(e) { console.error(e); }
})();
})();
